import { render } from "./TutorialGiftModal.vue?vue&type=template&id=53e63aa8&scoped=true"
import script from "./TutorialGiftModal.vue?vue&type=script&lang=js"
export * from "./TutorialGiftModal.vue?vue&type=script&lang=js"

import "./TutorialGiftModal.vue?vue&type=style&index=0&id=53e63aa8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e63aa8"]])

export default __exports__